<div *ngIf="config" class="container-block">

  <ng-container *ngIf="!isViewAll">

    <app-position-out-config
      [elementChoosing]="objectChoosing"
      [device]="device"
      [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config   
      [elementChoosing]="objectChoosing" 
      [device]="device"   
      [width]="class['frame-collapse']['width']"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>

    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">

      <!-- ----------------------------- THÀNH PHẦN ------------------------------ -->
      <li nz-submenu [nzTitle]="'thanh_phan' | translate" [(nzOpen)]="menuItemList" (nzOpenChange)="menuItemList = !menuItemList">
        <div class="config-name" style="flex-direction: unset;">
          <label>{{'cho_phep_mo_nhieu' | translate}}<br /><small>({{'xem_nhieu_noi_dung_mot_luc' | translate}})</small></label>
          <nz-switch [(ngModel)]="config.open_extra"
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
        <div>
          <ng-container *ngIf="objectChoosing.objects.length ">
            <!-- Thêm collapse -->
            <div class="example_btn" *ngIf="type == 'page'">
              <button class="_btn d-flex justify-content-between align-items-center p-1" (click)="addCollapse()">
                <span>{{'them_collapse_moi' | translate}}</span>
                <span class="ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span>
              </button>
            </div>
            <!-- Danh sách collapse -->
            <ul cdkDropList class="example-list" [style.height]="objectChoosing.objects.length <= 5 ? ' auto': '300px'"
              [style.min-height]="objectChoosing.objects.length <= 5 ? 'auto' : '300px'" 
              (cdkDropListDropped)="cdkDropListDropped($event)">
              <li class="example-box row m-0" [class.active]="item._id == rMessage.code"
                *ngFor="let item of objectChoosing.objects" cdkDrag>
                <div class="col p-0 d-flex align-items-center">
                  <!-- Nút kéo thay đổi thứ tự -->
                  <i class="bi bi-list example-handle mr-1" cdkDragHandle></i>
                  <!-- Tên collapse -->
                  <span class="p-0 m-0" data-toggle="tooltip" [title]="(item['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component)"
                    (click)="chooseSettingCollapse(item, $event)"
                    [style.font-weight]="item._id === collapseChoosing?._id ? 'bold' : ''">
                    {{ (item['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component)?.length >= 18 ? ((item['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component) | slice:0:15) + '...' : (item['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component) }}</span>
                </div>
                <!-- Nút edit -->
                <div *ngIf="type == 'page'">
                  <span nz-icon nzType="dash" nzTheme="outline" class="_icon_option"
                    (click)="$event.stopPropagation(); onContextMenu($event, menuObjectBlockFooter)">
                  </span>
                </div>
                <!-- Menu xóa/sửa collapse -->
                <nz-dropdown-menu #menuObjectBlockFooter="nzDropdownMenu">
                  <ul nz-menu [nzMode]="'vertical'">
                    <li nz-menu-item class="text-danger" (click)="$event.stopPropagation(); deleteCollapse(item)">
                      <i class="bi bi-trash mr-2"></i>
                      {{'xoa_collapse' | translate}}</li>
                  </ul>
                </nz-dropdown-menu>
              </li>
            </ul>
          </ng-container>

          <!-- Thông báo Vui lòng chọn collapse để cấu hình -->
          <div *ngIf="!collapseChoosing" class="my-3">
            <b style="line-height: 1.5;">{{'vui_long_chon_collapse_de_cau_hinh' | translate}} !</b>
          </div>
          <!-- Hiển thị cấu hình của collpase được chọn -->
          <div *ngIf="collapseChoosing" class="my-3">
            <!-- Tên collapse -->
            <label class="my-2">
              <b>{{'ten_collapse' | translate}}:</b> 
              {{ (collapseChoosing['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component).length >= 18 ? ((collapseChoosing['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component) | slice:0:15) + '...' : (collapseChoosing['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component) }}
            </label>
            <!-- Cấu hình tiêu đề collapse -->
            <div>
              <mat-form-field>
                <mat-label>{{'tieu_de' | translate}}</mat-label>
                <textarea matInput 
                  [ngModel]="collapseChoosing['name_' + functionService.selectedLanguageCode] | vhLanguage : 'name' : objectChoosing.component" 
                  (ngModelChange)="collapseChoosing['name_' + functionService.selectedLanguageCode] = $event" 
                  (blur)="updateCollapseChoosingName()"></textarea>
              </mat-form-field>
            </div>
            <!-- Ẩn nội dung (Nhấn vào tiêu đề sẽ không hiển thị nội dung) -->
            <div class="config-name">
              <p>{{'an_noi_dung' | translate}} <br /> <small>(Nhấn vào tiêu đề sẽ không hiển thị nội dung)</small></p>
              <nz-switch [(ngModel)]="collapseChoosing[device + '_config']['hide_body']"
                (ngModelChange)="updateCollapseChoosingConfig()">
              </nz-switch>
            </div>
            <!-- ICON TRƯỚC -->
            <li nz-submenu [nzTitle]="'bieu_tuong_truoc' | translate" [(nzOpen)]="menus.menu2" (nzOpenChange)="openHandler('menu2')">
              <!-- Sử dụng -->
              <div class="config-name mb-4">
                <p>{{'su_dung' | translate}}</p>
                <nz-switch [(ngModel)]="collapseChoosing[device + '_config']['icon_before']['hide']" 
                  (ngModelChange)="updateCollapseChoosingConfig()">
                </nz-switch>
              </div>
              <div class="my-3">
                <p>{{'chon_kieu_hien_thi' | translate}}</p>
                <nz-select [(ngModel)]="collapseChoosing[device + '_config']['icon_before']['type']" 
                  (ngModelChange)="updateCollapseChoosingConfig()"
                  nzPlaceHolder="{{'chon_icon_hoac_hinh_anh' | translate}}" allowClear
                  [disabled]="!collapseChoosing[device + '_config']['icon_before']['hide']">
                  <nz-option [nzValue]="'icon'" nzLabel="{{'icon' | translate}}"></nz-option>
                  <nz-option [nzValue]="'image'" nzLabel="{{'hinh_anh' | translate}}"></nz-option>
                </nz-select>
              </div>
              <ng-container *ngIf="collapseChoosing[device + '_config']['icon_before']['hide']">
                <!-- Kiểu icon -->
                <div *ngIf="collapseChoosing[device + '_config']['icon_before']['type'] === 'icon'">
                  <!-- Chọn icon -->
                  <div class="config-name mb-4">
                    <mat-icon>{{ collapseChoosing[device + '_config']['icon_before']['name'] }}</mat-icon>
                    <button nz-button nzType="default" style="border-radius: 5px" 
                      (click)="openDialogChooseIcon()"
                      [disabled]="!collapseChoosing[device + '_config']['icon_before']['hide']">
                      {{'thay_doi' | translate}}
                    </button>
                  </div>
                  <!-- Cấu hình cho icon -->
                  <div>
                    <!-- Kích thước icon -->
                    <div class="mb-4">
                      <div class="config-name">
                        <p>{{'kich_thuoc' | translate}}</p>
                        <nz-input-number [nzMin]="10" [nzMax]="50" [nzStep]="1"
                          [nzDisabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                          [ngModel]="collapseChoosing[device + '_class']['expansion-title__icon']['font-size'] | vhnumber" 
                          (ngModelChange)="collapseChoosing[device + '_class']['expansion-title__icon']['font-size'] = $event + 'px'" 
                          (nzBlur)="updateCollapseChoosingClass()">
                        </nz-input-number>
                      </div>
                      <div>
                        <nz-slider [nzMin]="10" [nzMax]="50" [nzStep]="1" 
                          [nzDisabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                          [ngModel]="collapseChoosing[device + '_class']['expansion-title__icon']['font-size'] | vhnumber" 
                          (ngModelChange)="collapseChoosing[device + '_class']['expansion-title__icon']['font-size'] = $event + 'px'" 
                          (nzOnAfterChange)="updateCollapseChoosingClass()">
                        </nz-slider>
                      </div>
                    </div>
                    <!-- Màu sắc icon -->
                    <div class="config-name">
                      <p>{{'mau_sac' | translate}}</p>
                      <div>
                        <input class="input-color" type="button"
                          [cpOKButton]="true" 
                          [disabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                          [style.background]="collapseChoosing[device + '_class']['expansion-title__icon']['color']"
                          [(colorPicker)]="collapseChoosing[device + '_class']['expansion-title__icon']['color']"
                          (colorPickerClose)="updateCollapseChoosingClass()" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Kiểu hình ảnh -->
                <div *ngIf="collapseChoosing[device + '_config']['icon_before']['type'] === 'image'" class="py-2">
                  <div style="margin-bottom: 12px">{{'nguon_hinh_anh' | translate}}</div>
                  <nz-select [(ngModel)]="collapseChoosing[device + '_config']['icon_before']['image_source']" 
                    (ngModelChange)="updateCollapseChoosingConfig()">
                    <nz-option [nzValue]="0" nzLabel="{{'tai_anh_len' | translate}}"></nz-option>
                    <nz-option [nzValue]="1" nzLabel="{{'chon_tu_thu_vien' | translate}}"></nz-option>
                    <nz-option [nzValue]="2" nzLabel="{{'duong_dan_hinh_anh' | translate}}"></nz-option>
                    <nz-option [nzValue]="3" nzLabel="{{'hinh_anh_mien_phi' | translate }}"></nz-option>
                  </nz-select>
                  <!-- Trường hợp tải ảnh từ máy -->
                  <div class="mt-2" *ngIf="collapseChoosing[device + '_config']['icon_before']['image_source'] == 0">
                    <label for="upload" class="upload-background-image">
                      <i class="bi bi-plus-circle"></i> {{'tai_anh_len' | translate}}
                    </label>
                    <input type="file" id="upload" (change)="handleUploadImg($event)" name="file" hidden />
                  </div>
                  <!-- Trường hợp tải ảnh từ thư viện -->
                  <button class="mt-2 upload-background-image" *ngIf="collapseChoosing[device + '_config']['icon_before']['image_source'] == 1"
                    (click)="openLibrary()">
                    <i class="bi bi-upload"></i>{{'chon_tu_thu_vien' | translate}}
                  </button>
                  <!-- Trường hợp chọn ảnh từ 1 đường dẫn bất kì -->
                  <div class="mt-2" *ngIf="collapseChoosing[device + '_config']['icon_before']['image_source'] == 2">
                    <textarea class="input custom-textarea w-100" name="background-image" id="background-image"
                      [(ngModel)]="collapseChoosing[device + '_config']['icon_before']['image_url']"
                      placeholder="{{'nhap_duong_dan_anh' | translate}}" 
                      (blur)="updateCollapseChoosingConfig()">
                    </textarea>
                    <!-- Nếu ảnh chứa id_subproject thì đã là ảnh trên server rồi nên sẽ disable -->
                    <button style="width: 100%;" nz-button nzType="primary" 
                      [disabled]="collapseChoosing[device + '_config']['icon_before']['image_url']?.includes(id_subproject)"
                      (click)="isShowConfirmPopup = true">
                      {{'chuyen_anh_len_server' | translate}}
                    </button>
                  </div>
                  <!-- Trường hợp chọn ảnh miễn phí -->
                  <div class="mt-2" *ngIf="collapseChoosing[device + '_config']['icon_before']['image_source'] == 3">
                    <label for="upload" (click)="openImageFree()" style="width: 100%">
                      <button class="upload-background-image">
                        <i class="bi bi-plus-circle"></i> {{'hinh_anh_mien_phi' | translate }}
                      </button>
                    </label>
                    <!-- Nếu ảnh chứa id_subproject thì đã là ảnh trên server rồi nên sẽ disable -->
                    <button style="width: 100%;" nz-button nzType="primary"
                      [disabled]="collapseChoosing[device + '_config']['icon_before']['image_url']?.includes(id_subproject)"
                      (click)="isShowConfirmPopup = true">
                      {{'chuyen_anh_len_server' | translate}}
                    </button>
                  </div>
                  <!-- Chiều rộng -->
                  <div class="mb-4">
                    <div class="config-name">
                      <p>{{'chieu_rong' | translate}}</p>
                      <nz-input-number [nzMin]="1" [nzMax]="100"
                        [nzDisabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                        [ngModel]="collapseChoosing[device + '_class']['expansion-title__image']['width'] | vhnumber" 
                        (ngModelChange)="collapseChoosing[device + '_class']['expansion-title__image']['width'] = $event + 'px'" 
                        (nzBlur)="updateCollapseChoosingClass()">
                      </nz-input-number>
                    </div>
                    <div>
                      <nz-slider [nzMin]="1" [nzMax]="100" 
                        [nzDisabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                        [ngModel]="collapseChoosing[device + '_class']['expansion-title__image']['width'] | vhnumber" 
                        (ngModelChange)="collapseChoosing[device + '_class']['expansion-title__image']['width'] = $event + 'px'" 
                        (nzOnAfterChange)="updateCollapseChoosingClass()">
                      </nz-slider>
                    </div>
                  </div>
                  <!-- Chiều cao -->
                  <div class="mb-4">
                    <div class="config-name">
                      <p>{{'chieu_cao' | translate}}</p>
                      <nz-input-number [nzMin]="1" [nzMax]="100"
                        [nzDisabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                        [ngModel]="collapseChoosing[device + '_class']['expansion-title__image']['height'] | vhnumber" 
                        (ngModelChange)="collapseChoosing[device + '_class']['expansion-title__image']['height'] = $event + 'px'" 
                        (nzBlur)="updateCollapseChoosingClass()">
                      </nz-input-number>
                    </div>
                    <div>
                      <nz-slider [nzMin]="1" [nzMax]="100" 
                        [nzDisabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                        [ngModel]="collapseChoosing[device + '_class']['expansion-title__image']['height'] | vhnumber" 
                        (ngModelChange)="collapseChoosing[device + '_class']['expansion-title__image']['height'] = $event + 'px'" 
                        (nzOnAfterChange)="updateCollapseChoosingClass()">
                      </nz-slider>
                    </div>
                  </div>
                </div>
              </ng-container>
              <!-- Khoảng cách icon và chữ -->
              <div class="mb-4">
                <div class="config-name">
                  <p>{{'khoang_cach_voi_chu' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="50"
                    [nzDisabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                    [ngModel]="class['expansion-title']['margin-left'] | vhnumber"
                    (ngModelChange)="class['expansion-title']['margin-left'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <div>
                  <nz-slider [nzMin]="0" [nzMax]="50"
                    [nzDisabled]="!collapseChoosing[device + '_config']['icon_before']['hide']"
                    [ngModel]="class['expansion-title']['margin-left'] | vhnumber"
                    (ngModelChange)="class['expansion-title']['margin-left'] = $event + 'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </div>
            </li>
            
            <!-- ICON SAU -->
            <li nz-submenu nzTitle="Icon sau" [(nzOpen)]="menus.menu3" (nzOpenChange)="openHandler('menu3')">
              <!-- Ẩn icon -->
              <div class="config-name">
                <p>{{'an_icon' | translate}}</p>
                <nz-switch [(ngModel)]="collapseChoosing[device + '_config']['icon_after']['hide']"
                  (ngModelChange)="updateCollapseChoosingConfig()">
                </nz-switch>
              </div>
              <ng-container *ngIf="!collapseChoosing[device + '_config']['icon_after']['hide']">
                <!-- Bộ icon (Thu gọn/ mở rộng nội dung) -->
                <div class="my-4">
                  <label>{{'bo_icon' | translate}} <br /><small>({{'thu_gon_mo_rong_noi_dung' | translate}})</small></label>
                  <button nz-button nz-dropdown [nzDropdownMenu]="menu"
                    class="p-0 w-100 d-flex justify-content-center" [nzPlacement]="'bottomCenter'">
                    <div style="font-size: 18px; display: flex; justify-content: space-around; align-items: center;">
                      <i [class]="collapseChoosing[device + '_config']['icon_after'].expand_icon" class="mr-2"></i>
                      <i [class]="collapseChoosing[device + '_config']['icon_after'].collapse_icon"></i>
                    </div>
                  </button>
                  <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                      <li nz-menu-item *ngFor="let item of bootstrapIconArrows" (click)="onChangeIcons(item)">
                        <div class="p-0 w-100 d-flex justify-content-center ">
                          <i [class]="item.expand_icon" class="mr-2"></i>
                          <i [class]="item.collapse_icon"></i>
                        </div>
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </div>
                <!-- Kích thước icon -->
                <div class="mb-4">
                  <div class="config-name">
                    <p>{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="50" [nzStep]="1"
                      [ngModel]="class['expansion-icon']['font-size'] | vhnumber" 
                      (ngModelChange)="class['expansion-icon']['font-size'] = $event + 'px'" 
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <div>
                    <nz-slider [nzMin]="10" [nzMax]="50" [nzStep]="1" 
                      [ngModel]="class['expansion-icon']['font-size'] | vhnumber" 
                      (ngModelChange)="class['expansion-icon']['font-size'] = $event + 'px'" 
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                </div>
                <!-- Màu sắc icon sau -->
                <div class="config-name">
                  <p>{{'mau_sac' | translate}}</p>
                  <div>
                    <input class="input-color" type="button"
                      [style.background]="class['expansion-icon']['color']"
                      [cpOKButton]="true" 
                      [(colorPicker)]="class['expansion-icon']['color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
              </ng-container>
            </li>
            <!-- LIÊN KẾT -->
            <li nz-submenu [nzTitle]="'lien_ket' | translate" [(nzOpen)]="menus.menu4" (nzOpenChange)="openHandler('menu4')"> 
              <app-link-page-config 
              [objectChoosing]="collapseChoosing"
                [staticdata]="collapseChoosing.staticdata" 
                [id_object]="collapseChoosing._id" 
                [dynamic_data]="objectChoosing.dynamic_data" 
                >
              </app-link-page-config>
            </li>
          </div>
        </div>
      </li>

      <!-- THÔNG SỐ CƠ BẢN -->
      <li nz-submenu [nzTitle]="'thong_so_co_ban' | translate">
        <ul>
          <!-- Định dạng -->
          <li nz-submenu [nzTitle]="'dinh_dang' | translate" [(nzOpen)]="menus.menu10" (nzOpenChange)="openHandler('menu10')">
            <!-- Màu nền -->
            <div class="config-name">
              <p>{{'mau_nen_chung' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="class['frame-collapse']['background-color']"
                  [(colorPicker)]="class['frame-collapse']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
            </div>
            <!-- Màu nền -->
            <div class="config-name">
              <p>{{'mau_nen_moi_collapse' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [style.background]="class['expansion-header']['background-color']"
                  [cpOKButton]="true" 
                  [(colorPicker)]="class['expansion-header']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
            </div>
            <!-- Khoảng cách giữa các collapse -->
            <div>
              <div class="config-name">
                <p>{{'khoang_cach_giua_cac_collapse' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="50"
                  [ngModel]="class['main_expansion']['gap'] | vhnumber"
                  (ngModelChange)="class['main_expansion']['gap'] = $event +'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <div>
                <nz-slider [nzMin]="0" [nzMax]="50" 
                  [ngModel]="class['main_expansion']['gap'] | vhnumber"
                  (ngModelChange)="class['main_expansion']['gap'] = $event +'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </div> 
            <!-- Chiều cao của các collapse -->
            <div>
              <div class="config-name">
                <p>{{'chieu_cao_cua_cac_collapse' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzMax]="100"
                  [ngModel]="class['expansion-header']['height'] | vhnumber" 
                  (ngModelChange)="class['expansion-header']['height'] = $event +'px'"
                  (nzBlur)="updateClass(); functionService.updateDimension(objectChoosing._id)">
                </nz-input-number>
              </div>
              <div>
                <nz-slider [nzMin]="1" [nzMax]="100" 
                  [ngModel]="class['expansion-header']['height'] | vhnumber"
                  (ngModelChange)="class['expansion-header']['height'] = $event +'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </div>
            <!-- Thời gian đóng/mở collapse -->
            <div>
              <div class="config-name">
                <p>{{'thoi_gian_dong_mo_collapse' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="5" [nzStep]="0.1"
                  [ngModel]="class['expansion-body']['transition'] | vhnumber"
                  (ngModelChange)="class['expansion-body']['transition'] = $event +'s'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <div>
                <nz-slider [nzMin]="0" [nzMax]="5" [nzStep]="0.1" 
                  [ngModel]="class['expansion-body']['transition'] | vhnumber"
                  (ngModelChange)="class['expansion-body']['transition'] = $event +'s'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
            </div> 
            <!-- Khoảng đệm -->
            <div>
              <app-padding-config
                [objectChoosing]="objectChoosing"
                [device]="device"
                [class]="class"
                [classPadding]="class['expansion-header']"
                [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
              </app-padding-config>
            </div>
          </li>

          <!-- Thanh cuộn -->
          <li nz-submenu [nzTitle]="'thanh_cuon' | translate" [(nzOpen)]="menus.menu5" (nzOpenChange)="openHandler('menu5')">
            <!-- Giới hạn chiều cao để cuộn -->
            <div class="config-name">
              <p>{{'gioi_han_chieu_cao_de_cuon' | translate}}</p>
              <nz-switch [(ngModel)]="config['max_height']"
                (ngModelChange)="updateMaxHeight()">
              </nz-switch>
            </div>
            <!-- Nếu Giới hạn chiều cao để cuộn === true -->
            <ng-container *ngIf="config['max_height']">
              <!-- Chiều cao tối đa -->
              <div>
                <div class="config-name">
                  <p>{{'chieu_cao_toi_da' | translate}}</p>
                  <nz-input-number [nzMin]="50" [nzMax]="1000"
                    [ngModel]="class['frame-collapse']['max-height'] | vhnumber"
                    (ngModelChange)="class['frame-collapse']['max-height'] = $event +'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="50" [nzMax]="1000" 
                    [ngModel]="class['frame-collapse']['max-height'] | vhnumber"
                    (ngModelChange)="class['frame-collapse']['max-height'] = $event +'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </div> 
              <!-- Khoảng cách với scrollbar -->
              <div>
                <div class="config-name">
                  <p>{{'khoang_cach_voi_thanh_cuon' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="200"
                    [ngModel]="class['frame-collapse']['padding-right'] | vhnumber"
                    (ngModelChange)="class['frame-collapse']['padding-right'] = $event +'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="0" [nzMax]="200" 
                    [ngModel]="class['frame-collapse']['padding-right'] | vhnumber"
                    (ngModelChange)="class['frame-collapse']['padding-right'] = $event +'px'"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </div>
              <!-- Độ rộng thanh cuộn -->
              <div>
                <div class="config-name">
                  <p>{{'do_rong_thanh_cuon' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="100"
                    [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                    (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                    (nzBlur)="updateConfig()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="1" [nzMax]="100" 
                    [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                    (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
              </div>
              <!-- Bo góc thanh cuộn -->
              <div>
                <div class="config-name">
                  <p>{{'bo_goc_thanh_cuon' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="100"
                    [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                    (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                    (nzBlur)="updateConfig()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="1" [nzMax]="100" 
                    [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                    (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
              </div>
              <!-- Màu nền thanh cuộn -->
              <div class="config-name mt-4">
                <p>{{'mau_nen_thanh_cuon' | translate}}</p>
                <div>
                  <input class="input-color" type="button"
                    [cpOKButton]="true" 
                    [style.background]="config['-webkit-scrollbar']['background-color']"
                    [(colorPicker)]="config['-webkit-scrollbar']['background-color']"
                    (colorPickerClose)="updateConfig()" />
                </div>
              </div>
              <!-- Màu thanh cuộn -->
              <div class="config-name mt-4">
                <p>{{'mau_thanh_cuon' | translate}}</p>
                <div>
                  <input class="input-color" type="button"
                    [cpOKButton]="true" 
                    [style.background]="config['-webkit-scrollbar']['thumb-background-color']"
                    [(colorPicker)]="config['-webkit-scrollbar']['thumb-background-color']"
                    (colorPickerClose)="updateConfig()" />
                </div>
              </div>
            </ng-container>
          </li>

          <!-- Định dạng chữ -->
          <li nz-submenu [nzTitle]="'dinh_dang_chu' | translate" [(nzOpen)]="menus.menu6" (nzOpenChange)="openHandler('menu6')">
            <div>
              <div class="config-name">
                <!-- Font-family -->
                <div style="width:65%">
                  <mat-form-field>
                    <mat-label>Font</mat-label>
                    <mat-select [(value)]="class['expansion-title']['font-family']"
                      [(ngModel)]="class['expansion-title']['font-family']" 
                      (ngModelChange)="updateClass()">
                      <mat-option *ngFor="let font of fonts" [value]="font.value" [style.font-family]="font.value">
                        {{font.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Kích thước -->
                <div style="width:35%">
                  <mat-form-field >
                    <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" 
                      [ngModel]="class['expansion-title']['font-size'] | vhnumber"
                      (ngModelChange)="class['expansion-title']['font-size'] = $event + 'px'"
                      (blur)="updateClass()" />
                  </mat-form-field>
                </div>
              </div>
              <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
              <div class="config-font">
                <p class="title-font">{{'kieu_chu' | translate}}</p>
                <div class="field-row">
                  <!-- In đậm -->
                  <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button 
                    [nzType]="class['expansion-title']['font-weight'] == 'bold' ? 'primary': 'default'" 
                    (click)=" class['expansion-title']['font-weight'] = class['expansion-title']['font-weight'] == 'bold' ? '400' : 'bold'; updateClass()">
                    <span style="font-weight:500">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button 
                    [nzType]="class['expansion-title']['font-style'] == 'italic'? 'primary': 'default'" 
                    (click)="class['expansion-title']['font-style'] = class['expansion-title']['font-style'] == 'normal' ? 'italic': 'normal'; updateClass()">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button 
                    [nzType]="class['expansion-title']['text-decoration'] == 'underline'? 'primary': 'default'" 
                    (click)="class['expansion-title']['text-decoration'] = class['expansion-title']['text-decoration'] == 'none' ? 'underline': 'none'; updateClass()">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- In hoa -->
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button 
                    [nzType]="class['expansion-title']['text-transform'] == 'uppercase'? 'primary': 'default'" 
                    (click)="class['expansion-title']['text-transform'] = class['expansion-title']['text-transform'] == 'none' ? 'uppercase': 'none'; updateClass()">
                    <span>AB</span>
                  </button>
                  <!-- Màu chữ -->
                  <div>
                    <input id="color" type="button" 
                      [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
                      [cpOKButton]="true" 
                      [(colorPicker)]="class['expansion-title']['color']"
                      [style.background]="class['expansion-title']['color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
              </div>
              <!-- Canh lề -->
              <div class="my-4">
                <p>{{'canh_le' | translate}}</p>
                <div class="font">
                  <!-- Lề trái -->
                  <button nz-button class="align-button" title="flex-start" 
                    [nzType]="class['expansion-title']['text-align'] === 'left'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['expansion-title']['text-align'] = 'left'; updateClass()">
                    <i nz-icon nzType="align-left" nzTheme="outline"></i>
                  </button>
                  <!-- Canh giữa -->
                  <button nz-button class="align-button" title="center"
                    [nzType]="class['expansion-title']['text-align'] === 'center'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['expansion-title']['text-align'] = 'center'; updateClass()">
                    <i nz-icon nzType="align-center" nzTheme="outline"></i>
                  </button>
                  <!-- Lề phải -->
                  <button nz-button class="align-button" title="flex-end"
                    [nzType]="class['expansion-title']['text-align'] === 'right'
                      ? 'primary'
                      : 'default'" 
                    (click)="class['expansion-title']['text-align'] = 'right'; updateClass()">
                    <i nz-icon nzType="align-right" nzTheme="outline"></i>
                  </button>
                </div>
              </div>
              <!-- Khoảng cách dòng -->
              <div>
                <div class="config-name">
                  <p>{{'khoang_cach_dong' | translate}}</p>
                  <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['expansion-title']['line-height']"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div> 
                <div>
                  <nz-slider [nzMin]="1" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['expansion-title']['line-height']"
                    (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </div>
            </div>
          </li>

          <!-- CẤU HÌNH VIỀN -->
          <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="menus.menu7" (nzOpenChange)="openHandler('menu7')">
            <app-borders-config 
            [elementChoosing]="objectChoosing"
              [id_object]="objectChoosing._id"
              [device]="device" 
              [class]="class" 
              [borderClass]="class['expansion-header']">
            </app-borders-config>
          </li>

          <!-- CẤU HÌNH BO TRÒN -->
          <li nz-submenu [nzTitle]="'bo_tron' | translate" [(nzOpen)]="menus.menu8" (nzOpenChange)="openHandler('menu8')">
            <app-borders-radius-config 
            [elementChoosing]="objectChoosing"
              [id_object]="objectChoosing._id"
              [device]="device" 
              [class]="class" 
              [borderRadiusClass]="class['expansion-header']">
            </app-borders-radius-config>
          </li>

          <!-- CẤU HÌNH ĐỔ BÓNG TỔNG -->
          <li nz-submenu [nzTitle]="'do_bong_tong' | translate" [(nzOpen)]="menus.menu11" (nzOpenChange)="openHandler('menu11')">
            <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['frame-collapse']"
              [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
            </app-shadow-config>
          </li>
        </ul>
      </li>
      <!-- ------------------------------ HIỂN THỊ ------------------------------- -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="menus.menu15" (nzOpenChange)="openHandler('menu15')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <div>
          <app-hide-show-config 
            [elementChoosing]="objectChoosing"
            [device]="device">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu [nzTitle]="'hieu_ung' | translate" [(nzOpen)]="menus.menu9" (nzOpenChange)="openHandler('menu9')">
        <app-choose-animations-config
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="objectChoosing.staticdata"
          [cursorClass]="class['expansion-header']"
          [effect_hover]="effect_hover"
          [customize]="customize"
          [effectFileUsing]="'frame-collapse'"
          [elementChoosing]="objectChoosing"
        >
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="editor-header">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 1">
      <app-animations-config
        [staticdata]="objectChoosing.staticdata"
        [id_object]="objectChoosing._id"
        [customize]="customize"
        [device]="device"
        [elementChoosing]="objectChoosing"
      ></app-animations-config>
    </div>
  </div>
</div>